
const WAIT_REDIRECT_SECONDS = process.env.REACT_APP_WAIT_REDIRECT_SECONDS
const WAIT_REDIRECT_WITH_WARNING_SECONDS = process.env.REACT_APP_WAIT_REDIRECT_WITH_WARNING_SECONDS

export {
  WAIT_REDIRECT_SECONDS,
  WAIT_REDIRECT_WITH_WARNING_SECONDS
}